export default function () {
  this.doLoad()
}



// WEBPACK FOOTER //
// ./src/app/dweller/profile/me/components/overview/resources/mounted.js